import { TRUNCATION_SUFFIX } from './chart-label-strategy';
import type { LabelStrategy } from './chart-label-strategy';

type ChartAxisTickProps = {
  x?: number;
  y?: number;
  payload?: { value: unknown };
  strategy: LabelStrategy;
  fontSize?: number;
  labelFormatter?: (value: unknown) => string;
};

const truncateLabel = (label: string, maxLength: number): string => {
  if (label.length <= maxLength) return label;
  return label.slice(0, maxLength - TRUNCATION_SUFFIX.length) + TRUNCATION_SUFFIX;
};

export const ChartAxisTick = ({
  x = 0,
  y = 0,
  payload,
  strategy,
  fontSize = 12,
  labelFormatter,
}: ChartAxisTickProps) => {
  const rawLabel = String(payload?.value ?? '');
  const formattedLabel = labelFormatter ? labelFormatter(payload?.value) : rawLabel;
  const displayLabel =
    strategy.truncateAt != null
      ? truncateLabel(formattedLabel, strategy.truncateAt)
      : formattedLabel;
  const shouldRenderTitle = rawLabel.length > 0 && rawLabel !== displayLabel;

  return (
    <g transform={`translate(${x},${y})`}>
      {shouldRenderTitle ? <title>{rawLabel}</title> : null}
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor={strategy.textAnchor}
        fontSize={fontSize}
        fill='#666'
        transform={strategy.angle !== 0 ? `rotate(${strategy.angle})` : undefined}
      >
        {displayLabel}
      </text>
    </g>
  );
};

export { truncateLabel };
